import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import AdminInviteRoomView from '../../../../containers/ChatRooms/Room/Admin/Room/AdminInviteRoom';
import { useTokenCallback } from '../../../../utils/hooks/useTokenCallback';

const AdminInviteRoom = ({match}) => {
  const {roomInfo} = useSelector(state=>state.userInfo)
    const [usersToInvite, setUsersToInvite] = useState([]);
    useTokenCallback(()=>{
        
    },[])
  return <AdminInviteRoomView room={roomInfo} usersToInvite={usersToInvite} setUsersToInvite={setUsersToInvite}/>;
};

export default AdminInviteRoom;
